export interface DirectoryRecordItemType {
  id: string;
  isArchived: boolean;
  isArchivable: boolean;
  versionNumber?: number;
  [key: string]: string | null | boolean | number | undefined | Date;
}

export enum DirectoryRecordOptionType {
  archive,
  dearchive,
}

export interface DocumentColumnArgs {
  editable?: boolean;
  canDeleteAnyDocument?: boolean;
  onClickOption: (
    item: DirectoryRecordItemType,
    option: DirectoryRecordOptionType
  ) => void;
}
